import { AuthGuard } from "@aihub/core/authorization";
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DownloadComponent } from '../app/components/download.component';

const routes: Routes = [{
  path: '',
  component: DownloadComponent,
  canActivate: [AuthGuard]
}];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
